import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const MemberItemTwo = ({ data }) => {
  const navigate = useNavigate();

  if (!data) return null;

  const handleClick = async () => {
    const token = localStorage.getItem("token");
    const loggedInUserId = localStorage.getItem("user_id");

    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/user/has-plan`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.has_plan || loggedInUserId === String(data.id)) {
        navigate("/profile", { state: { userId: data.id } });
      } else {

        navigate("/pricing", { state: { from: { pathname: "/profile", userId: data.id } } });
      }
    } catch (err) {
      console.error("Plan check failed", err);
      navigate("/pricing", { state: { from: { pathname: "/profile", userId: data.id } } });
    }
  };

  return (
    <div className="col member-item-card"  onClick={handleClick}>
      <div className="lab-item member-item style-1 style-2">
        <div className="lab-inner">
          <div className="lab-thumb">
            <img
              src={data.imgUrl || "/assets/images/member/default.jpg"}
              alt={data.imgAlt || "member"}
            />
          </div>
          <div className="lab-content">
            <h6>
              <span
                style={{ cursor: "pointer", }}
                onClick={handleClick}
              >
                {data.memName}
              </span>
            </h6>
            <p>{data.memActive || "Active recently"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberItemTwo;
